import { Illustration } from '@react-spectrum/icon';
import React from 'react';
export default function Error504(props) {
  return /*#__PURE__*/React.createElement(Illustration, props, /*#__PURE__*/React.createElement("svg", {
    width: "137",
    height: "94"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-404.3 -3780.5)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.8 3803v-19a2.006 2.006 0 012-2h118a2.006 2.006 0 012 2v23a2.006 2.006 0 01-2 2h-102M435.8 3814h102a2.006 2.006 0 012 2v23a2.006 2.006 0 01-2 2h-102M435.8 3846h102a2.006 2.006 0 012 2v23a2.006 2.006 0 01-2 2h-118a2.006 2.006 0 01-2-2v-17M527.8 3842v3M527.8 3810v3",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(523.8 3791.5)",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(523.8 3824)",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(523.8 3855.5)",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.8 3844.4v3.6h-24v-3.6c0-9.1 9-10.9 9-15.4v-.9c0-4.5-9-6.3-9-15.4v-3.6h24v3.6c0 9.1-9 10.9-9 15.4v.9c0 4.5 9 6.3 9 15.4z",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.6 3846.8l-8.4-8.4a3.441 3.441 0 00-4.8 0l-8.4 8.4",
    strokeWidth: "2"
  }))));
}